import React, { useEffect, useState } from 'react'
import { Chart, ArgumentAxis, ValueAxis, AreaSeries, Legend } from '@devexpress/dx-react-chart-material-ui'
import { ArgumentScale, Animation } from '@devexpress/dx-react-chart'

import { scalePoint } from 'd3-scale'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import { CircularProgress, Grid, Typography } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },

  nenhumexame: {
    paddingTop: '8px',
  },
}))

const chartRootStyles = {
  chart: {
    paddingRight: '20px',
  },
}
const legendStyles = {
  root: {
    display: 'flex',
    margin: 'auto',
    flexDirection: 'row',
  },
}
const legendLabelStyles = (theme) => ({
  label: {
    paddingTop: theme.spacing(1),
  },
})
const legendItemStyles = {
  item: {
    flexDirection: 'column',
  },
}

const ChartRootBase = ({ classes, ...restProps }) => <Chart.Root {...restProps} className={classes.chart} />
const LegendRootBase = ({ classes, ...restProps }) => <Legend.Root {...restProps} className={classes.root} />
const LegendLabelBase = ({ classes, ...restProps }) => <Legend.Label {...restProps} className={classes.label} />
const LegendItemBase = ({ classes, ...restProps }) => <Legend.Item {...restProps} className={classes.item} />
const ChartRoot = withStyles(chartRootStyles, { name: 'ChartRoot' })(ChartRootBase)
const LegendRoot = withStyles(legendStyles, { name: 'LegendRoot' })(LegendRootBase)
const LegendLabel = withStyles(legendLabelStyles, { name: 'LegendLabel' })(LegendLabelBase)
const LegendItem = withStyles(legendItemStyles, { name: 'LegendItem' })(LegendItemBase)

export const ExamesDeUsuario = () => {
  const exameRealizadoService = useExameRealizadoService()
  const classes = useStyles()
  const [examesAtribuidos, setExamesAtribuidos] = useState([])
  const [processandoExamesAtribuidos, setProcessandoExamesAtribuidos] = useState(false) //eslint-disable-line
  const [examesTerminados, setExamesTerminados] = useState([])
  const [processandoExamesTerminados, setProcessandoExamesTerminados] = useState(false) //eslint-disable-line
  const [data, setData] = useState([{ tempo: '00/00/0000', atribuidos: 0, finalizados: 0 }])

  useEffect(() => {
    exameRealizadoService.listarExamesRealizadosDeUsuarioIntervaloDeTempo('DIA', setExamesAtribuidos, setProcessandoExamesAtribuidos)
    exameRealizadoService.listarExamesRealizadosPorStatusDeUsuarioIntervaloDeTempo('Terminado', 'DIA', setExamesTerminados, setProcessandoExamesTerminados)
  }, [])

  const dataFormatada = (string) => string.replace(/([0-9]{4}-[0-9]{2}-[0-9]{2})(T00:00:00.000Z)/, '$1')

  const dataFormatadaLabel = (string) => string.replace(/[0-9]{4}-([0-9]{2})-([0-9]{2})(T00:00:00.000Z)/, '$2/$1')

  const verificarPeriodoJaInserido = (datasCadastradas, novaData) => {
    let cadastrada = false
    datasCadastradas.forEach((dataCadastrada) => {
      if (dataCadastrada.tempo === novaData.tempo) {
        cadastrada = true
      }
    })
    return cadastrada
  }

  const buscarIndiceEncaixe = (datasCadastradas, novaData) => {
    let indice = 0
    datasCadastradas.forEach((dataCadastrada) => {
      if (novaData.date > dataCadastrada.date) {
        indice += 1
      }
    })
    return indice
  }

  const empurrarValoresParaFrente = (datasCadastradas, indice) => {
    const result = [...datasCadastradas]
    for (let i = result.length; i > indice; i -= 1) {
      result[i] = datasCadastradas[i - 1]
    }
    return result
  }

  useEffect(() => {
    const dadosAtribuidos = []
    const dadosFinalizados = []

    examesAtribuidos.forEach((exameAtribuido, index) => {
      dadosAtribuidos.push({
        tempo: dataFormatadaLabel(exameAtribuido.data),
        atribuidos: dadosAtribuidos[index - 1] ? parseInt(exameAtribuido.quantidade, 10) + parseInt(dadosAtribuidos[index - 1].atribuidos, 10) : parseInt(exameAtribuido.quantidade, 10),
        finalizados: 0,
        date: new Date(dataFormatada(exameAtribuido.data)),
      })
    })

    examesTerminados.forEach((exameTerminado, index) => {
      dadosFinalizados.push({
        tempo: dataFormatadaLabel(exameTerminado.data),
        atribuidos: 0,
        finalizados: dadosFinalizados[index - 1] ? parseInt(exameTerminado.quantidade, 10) + parseInt(dadosFinalizados[index - 1].finalizados, 10) : parseInt(exameTerminado.quantidade, 10),
        date: new Date(dataFormatada(exameTerminado.data)),
      })
    })

    let dadosMerge = []
    dadosMerge = [...dadosAtribuidos]
    dadosFinalizados.forEach((dadoFinalizado) => {
      const cadastrada = verificarPeriodoJaInserido(dadosMerge, dadoFinalizado)

      if (cadastrada) {
        const indiceEncaixe = buscarIndiceEncaixe(dadosMerge, dadoFinalizado)
        dadosMerge[indiceEncaixe].finalizados = dadoFinalizado.finalizados
      } else {
        const indiceEncaixe = buscarIndiceEncaixe(dadosMerge, dadoFinalizado)
        dadosMerge = empurrarValoresParaFrente(dadosMerge, indiceEncaixe)
        dadosMerge[indiceEncaixe] = {
          ...dadoFinalizado,
          atribuidos: dadosMerge[indiceEncaixe - 1] ? dadosMerge[indiceEncaixe - 1].atribuidos : 0,
        }
      }
    })

    const dadosFinalizadosNaoPreenchidos = dadosMerge.map((dado, index) => {
      if (dado.finalizados === 0 && dadosMerge[index - 1]) {
        return {
          ...dado,
          finalizados: dadosMerge[index - 1].finalizados,
        }
      }
      return dado
    })

    if (!examesAtribuidos.length) {
      setData([{ tempo: '00/00', atribuidos: 0, finalizados: 0 }])
    } else if (dadosFinalizadosNaoPreenchidos.length) {
      setData(dadosFinalizadosNaoPreenchidos)
    }
  }, [examesAtribuidos, examesTerminados])

  return (
    <div>
      {processandoExamesAtribuidos || processandoExamesTerminados ? (
        <div>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <div>
          {data && data.length ? (
            <Chart data={data} rootComponent={ChartRoot} className={classes.chart}>
              <ArgumentScale factory={scalePoint} />
              <ArgumentAxis />
              <ValueAxis />

              <AreaSeries name="Atribuidos" valueField="atribuidos" argumentField="tempo" />
              <AreaSeries name="Finalizados" valueField="finalizados" argumentField="tempo" />
              <Animation />
              <Legend position="bottom" rootComponent={LegendRoot} itemComponent={LegendItem} labelComponent={LegendLabel} />
            </Chart>
          ) : (
            <Grid container justifyContent="center" alignItems="center" className={classes.nenhumexame}>
              <Typography className={classes.nenhumexame} variant="h5">
                Exames atribuidos x Exames finalizados (nenhum registrado)
              </Typography>
            </Grid>
          )}
        </div>
      )}
    </div>
  )
}
